var modules_51d8f436 = {"arrow":"Pagination_module_arrow__b8d27768"};
import "../../../assets/esm/components/Table/src/Pagination~Bx-nfOj4.css";

export { modules_51d8f436 as default };
//# sourceMappingURL=Pagination.module.less.js.map
